const backgroundColor = '#281978';
const linkColor = '#ffffff';

export const fallbackValuesLegacy = {
  backgroundColor: '#3b414d',
  linkColor: '#ffffff',
};

export const fallbackValues = {
  backgroundColor,
  linkColor,
};
